import moment from 'moment';

import { ImmigrationBook as API } from '@src/api/types';
import { ImmigrationBook as Data } from '@src/types';

import generateMedia from './media';

const Factory = (api: API): Data => ({
  id: api.id,
  title: api.title,
  bookmarked: api.bookmarked,
  categories: api.categories,
  cover: generateMedia(api.cover),
  date: moment.unix(api.date / 1000),
  // date: api.date,
  description: api.description,
  labels: api.labels,
  language: api.language.toLowerCase(),
  pagesCount: api.pagesCount,
  publisher: api.publisher,
  score: api.score,
  scoreCount: api.scoreCount,
  translator: api.translator,
  type: api.type,
  status: api.status,
});

export default Factory;
